import * as React from 'react'
import { TrapezoidButton } from '@components/controls/buttons/trapezoid-button'
import { IconWithText } from '@components/icon-with-text'
import { ConfettiRef, ConfettiWrapper } from '@components/confetti-wrapper'
import clsx from 'clsx'
import { Button } from 'reactstrap'

interface Props {
  isSelected: boolean
  onSelectionChange: () => void
  text?: string
  activeText?: string
  className?: string
  icon?: string
  appearance?: 'trapezoid' | 'solid'
}

export const OfferSelectionButton = ({
  isSelected,
  onSelectionChange,
  text = 'Wybieram',
  activeText = 'Wybrany',
  className,
  icon = 'uil-shopping-bag',
  appearance = 'trapezoid',
}: Props): JSX.Element => {
  const confettiRef = React.useRef<ConfettiRef>(null)

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation()
    onSelectionChange()

    if (!isSelected) {
      confettiRef.current?.play()
    }
  }

  const buttonContent = isSelected ? (
    <IconWithText text={activeText} iconClassName="uil-check font-xxxl me-2 lh-initial" textClassName="text-nowrap" />
  ) : (
    <IconWithText text={text} iconClassName={clsx('font-xxxl me-2 lh-initial', icon)} textClassName="text-nowrap" />
  )

  const solidButtonContent = isSelected ? (
    <IconWithText
      text={activeText}
      iconClassName="uil-check font-xxl me-2 lh-initial z-index-1"
      className="text-white justify-content-center"
      textClassName="font-lg"
    />
  ) : (
    <IconWithText
      text={text}
      iconClassName={clsx('font-xxl me-2 lh-initial z-index-1', icon)}
      className="text-white justify-content-center"
      textClassName="font-lg"
    />
  )

  if (appearance === 'solid') {
    return (
      <ConfettiWrapper ref={confettiRef}>
        <Button
          className={clsx(
            'order-now-button btn rounded py-2 px-4 fw-bold border-0 w-100',
            isSelected ? 'btn-success' : 'btn-danger',
            className,
          )}
          onClick={handleClick}
          type="button"
        >
          {solidButtonContent}
        </Button>
      </ConfettiWrapper>
    )
  }

  return (
    <ConfettiWrapper ref={confettiRef}>
      <TrapezoidButton onClick={handleClick} variant={isSelected ? 'success' : 'danger'} className={className}>
        {buttonContent}
      </TrapezoidButton>
    </ConfettiWrapper>
  )
}
